import { Injectable } from '@angular/core';
import { RemitaModel } from '../model/remita.model';
import { ApiService } from 'src/services/api.service';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';


@Injectable({
  providedIn: 'root'
})
export class RemitaPaymentService {

  remita: RemitaModel | any;
  paymentTransactionHistory: any;

  constructor(private apiService: ApiService) {
  }

  get paymentInfo() {
      let pi = sessionStorage.getItem("paymentInfo");
      let paymentInfo = JSON.parse(pi == null ? "{}" : pi);
      return paymentInfo;
  }

  generateRRR(request: any): Observable<any> {
      if (request == null) {
        request = {
            totalAmount: this.paymentInfo.totalAmount,
            entityId: this.paymentInfo.persistMasterId,
            processTypeId: this.paymentInfo.processTypeId,
            entityName: this.paymentInfo.entityName,
            feeDescription: this.paymentInfo.paymentDue[0].name,
            returnBackUrl: environment.baseURL+"/payment-history"
        }
      }
      const url = "/payment/remita/start-payment";
      this.apiService.suppressAlertError = true;
      return this.apiService.post_(url, request);
  }

  acknowledgementRRR(rrr: any, orderId: any): Observable<any> {
      const url = "/payment/remita/remitta_acknowledge";
      return this.apiService.post_(url, { 'rrr': rrr, 'orderId': orderId });
  }

  validatePayment(transactionId: number): Observable<any> {
      const url = "/payment/validate-transaction/" + transactionId;
      return this.apiService.get_(url);
  }

  downloadReceipt(): Observable<any> {
      const url = "/utility/generate/receipt/" + this.paymentTransactionHistory.id;
      return this.apiService.downloadFile(url);
  }
}
